// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// import 'assets/custom-theme/index.css'; // 换肤版本element-ui css

import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条 样式
import 'normalize.css/normalize.css'; // normalize.css 样式格式化
import 'assets/iconfont/iconfont'; // iconfont 具体图标见https://github.com/PanJiaChen/vue-element-admin/wiki
import * as filters from './filters'; // 全局vue filter
import Multiselect from 'vue-multiselect'; // 使用的一个多选框组件，element-ui的select不能满足所有需求
import 'vue-multiselect/dist/vue-multiselect.min.css'; // 多选框组件css
import Sticky from 'components/Sticky'; // 粘性header组件
import IconSvg from 'components/Icon-svg'; // svg 组件
import vueWaves from './directive/waves'; // 水波纹指令
import errLog from 'store/errLog'; // error log组件
//import './mock/index.js';  // 该项目所有请求使用mockjs模拟                                                                               

import {
  getToken
} from 'utils/auth';

import VueI18n from 'vue-i18n' //国际化
import enLang from './common/lang/en.js'
import zhCNLang from './common/lang/zh-cn.js'
import zhTWLang from './common/lang/zh-tw.js'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'

import ifvisible from 'ifvisible.js'
import {Message, MessageBox} from 'element-ui'

// import './styles/index.scss';

// register globally
Vue.component('multiselect', Multiselect);
Vue.component('Sticky', Sticky);
Vue.component('icon-svg', IconSvg)

Vue.use(VueI18n)

const messages = {
  en: enLang,
  zh_cn: zhCNLang,
  zh_tw:zhTWLang
}
// Create VueI18n instance with options

if(!localStorage.getItem('locale')){
	localStorage.setItem('locale','en');
}

let i18n = new VueI18n({
  locale: localStorage.getItem('locale'), // set locale
  messages, // set locale messages
})

let locale;
if( localStorage.getItem('locale') === 'en' ){
  locale = enLocale;
} else if( localStorage.getItem('locale') === 'zh_cn' ){
  locale = zhCNLocale;
} else if( localStorage.getItem('locale') === 'zh_tw' ){
  locale = zhTWLocale;
}

Vue.use(ElementUI, { 
    // i18n: (key, value) => i18n.vm._t(key, value)
    // i18n: (key, value) => i18n.t(key, value)
		locale
})

new Vue({ i18n }).$mount('#app')

Vue.use(vueWaves);
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

// register global progress.
const whiteList = ['/login', '/authredirect']; // 不重定向白名单
router.beforeEach((to, from, next) => {
  $('html').css({
    'background-color': '#fff'
 });
 $(".sidebar-container .el-menu--inline .el-menu-item").removeClass('is-active');
  NProgress.start(); // 开启Progress
  if (sessionStorage.getItem("access-token")) { // 判断是否有token
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      if (store.getters.menus === undefined) { // 判断当前用户是否有侧边栏menu的数据（不在在menu）
        store.dispatch('GetInfo').then(info => { // 拉取user_info
          const menus = {};
//        console.log(info);
          for (let i = 0; i < info.value.menus.length; i++) {
            menus[info.value.menus[i].code] = true;
          }
          store.dispatch('GenerateRoutes', menus).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to
            }); // hack方法 确保addRoutes已完成
          })
        }).catch((error) => {
          console.log(error)
          sessionStorage.removeItem('access-token')
          next({
            path: '/login'
          });
          NProgress.done();
          //      	this.$router.push({ path: '/login' })
          //      	next({ path: '/login' });
          //        store.dispatch('FedLogOut').then(() => {
          //          next({ path: '/login' });
          //        })
        })

      } else {
        
        //  else {
        //   // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        //   if (hasPermission(store.getters.roles, to.meta.role)) {
        //     next();//
        //   } else {
        // 存在menu直接执行下一步
        next();
        //   }
        //   // 可删 ↑
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login'); // 否则全部重定向到登录页
      NProgress.done(); // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

Vue.config.productionTip = false;

// 生产环境错误日志
if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = function (err, vm) {
    console.log(err, window.location.href);
    errLog.pushLog({
      err,
      url: window.location.href,
      vm
    })
  };
}
let timeId;
ifvisible.setIdleDuration(10);
ifvisible.on("idle", function(){
  clearTimeout(timeId);
  // Stop auto updating the live data
  // console.log('idle');
  timeId = setTimeout(function(){
    let timeMsg;
    if(localStorage.getItem('locale') === 'zh_cn'){
       timeMsg = '闲置时间过长，请重新登录';
    }else if(localStorage.getItem('locale') === 'zh_tw'){
       timeMsg = '閒置時間過長，請重新登入';
    }else{
       timeMsg = 'Idle for too long, please re-login';
    }
    // console.log(this);
    Message({ message: timeMsg, duration: 3 * 1000 });
    // alert(timeMsg);
    setTimeout(function(){
      // alert('main-idle');
      sessionStorage.removeItem('access-token');
      localStorage.clear();
      location.reload();
    }, 4000);
    // location.reload(); // 为了重新实例化vue-router对象 避免bug
    // this.$router.push({ name: '登录', }).then(() => {
      
    // });
    clearTimeout(timeId);
  },1800000);
});
ifvisible.on("blur", function(){
  clearTimeout(timeId);
  // example code here..
  timeId = setTimeout(function(){
    let timeMsg;
    if(localStorage.getItem('locale') === 'zh_cn'){
       timeMsg = '闲置时间过长，请重新登录';
    }else if(localStorage.getItem('locale') === 'zh_tw'){
       timeMsg = '閒置時間過長，請重新登入';
    }else{
       timeMsg = 'Idle for too long, please re-login';
    }
    // console.log(this);
    Message({ message: timeMsg, duration: 3 * 1000 });
    // alert(timeMsg);
    setTimeout(function(){
      // alert('main-blur');
      sessionStorage.removeItem('access-token');
      localStorage.clear(); 
      location.reload();
    }, 4000);
    // location.reload(); // 为了重新实例化vue-router对象 避免bug
    // this.$router.push({ name: '登录', }).then(() => {
      
    // });
    clearTimeout(timeId);
  },1800000);
});
ifvisible.on("wakeup", function(){
  // go back updating data
  // console.log('wakeup');
  clearTimeout(timeId);
});



const vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: {
    App,
  }
})


Date.prototype.Format = function (fmt) { //author: meizz 
  const o = {
    "M+": this.getMonth() + 1, //月份 
    "d+": this.getDate(), //日 
    "h+": this.getHours(), //小时 
    "m+": this.getMinutes(), //分 
    "s+": this.getSeconds(), //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}



// WEBPACK FOOTER //
// ./src/main.js